import React from 'react';
import { Box, Typography, Button, Chip } from '@mui/material';
import { confirm } from 'components/MenuNew/ConfirmModal';

function TierConfigHeader({ isUsingDefaults, onResetToDefaults }) {
  const handleReset = async () => {
    const confirmed = await confirm({
      title: 'Reset to Defaults',
      message:
        'This will remove your custom tier configuration and revert to the default tiers (Bronze, Silver, Gold, Platinum). Continue?',
      cancelText: 'Cancel',
      confirmText: 'Reset to Defaults',
      confirmColor: 'primary',
    });
    if (confirmed) {
      await onResetToDefaults();
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        mb: 3,
      }}
    >
      <Box>
        <Typography variant="h5" component="h1" sx={{ fontWeight: 600 }}>
          Customer Tiers
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Configure how customers are ranked based on their order history
        </Typography>
        {isUsingDefaults !== undefined && (
          <Chip
            label={isUsingDefaults ? 'Using defaults' : 'Custom'}
            size="small"
            color={isUsingDefaults ? 'default' : 'primary'}
            sx={{ mt: 1 }}
          />
        )}
      </Box>
      <Button
        variant="outlined"
        color="error"
        onClick={handleReset}
        size="medium"
      >
        Reset to Defaults
      </Button>
    </Box>
  );
}

export default TierConfigHeader;
